import { motion } from 'framer-motion';

const steps = [
  {
    num: '01',
    title: 'Submit Your Prescription',
    description:
      'Bring in your prescription in person, ask your doctor to fax it directly, or transfer from another pharmacy. Our team will verify all details before dispensing.',
  },
  {
    num: '02',
    title: 'Insurance & Coverage Review',
    description:
      'We process your insurance claim in real time and explore generic alternatives to minimize your out-of-pocket costs — no extra steps needed from you.',
  },
  {
    num: '03',
    title: 'Pharmacist Consultation',
    description:
      'A licensed pharmacist reviews your medication for interactions, advises on proper use, and answers any questions before you leave or before delivery.',
  },
  {
    num: '04',
    title: 'Pick Up or Free Delivery',
    description:
      'Your prescription is ready in as little as 15 minutes. Prefer delivery? We offer free home delivery throughout Thornhill and the surrounding GTA communities.',
  },
];

export default function PharmacyProcess() {
  return (
    <section aria-labelledby="process-heading" className="mb-20">
      <motion.div
        initial={{ opacity: 0, y: 18 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6, ease: 'easeOut' }}
        className="mb-10"
      >
        <p className="text-xs font-semibold text-teal-600 uppercase tracking-[0.15em] mb-4">How It Works</p>
        <h2 id="process-heading" className="text-3xl font-bold text-gray-900 mb-3 leading-snug">
          How our pharmacy services work
        </h2>
        <p className="text-gray-500 max-w-xl text-[0.94rem] leading-relaxed">
          We make the process effortless — from receiving your prescription to getting your medication safely
          into your hands, every step is handled with precision and care.
        </p>
      </motion.div>

      {/* Timeline */}
      <ol role="list" className="relative">
        {/* vertical line */}
        <div className="absolute left-[22px] top-0 bottom-0 w-px bg-gray-200" aria-hidden="true" />

        {steps.map((step, i) => (
          <motion.li
            key={i}
            initial={{ opacity: 0, x: -16 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: i * 0.1, ease: 'easeOut' }}
            className="relative flex gap-7 pb-10 last:pb-0"
          >
            {/* Number node */}
            <div
              className="relative z-10 w-11 h-11 flex-shrink-0 rounded-full bg-white border border-gray-300 flex items-center justify-center"
              aria-hidden="true"
            >
              <span className="text-xs font-bold text-teal-600 tracking-wide">{step.num}</span>
            </div>

            {/* Content */}
            <div className="pt-2 pb-1">
              <h3 className="text-sm font-semibold text-gray-900 mb-1.5">{step.title}</h3>
              <p className="text-sm text-gray-500 leading-relaxed max-w-lg">{step.description}</p>
            </div>
          </motion.li>
        ))}
      </ol>
    </section>
  );
}
